<template>
    <CRow>
        <CCol col>
            <div style="width:100%; height: 75vh;">
                <ejs-grid ref='gridccl' :dataSource="ccLogsData" :allowFiltering='true' :allowPaging="true" :allowResizing='true' :toolbarClick='toolbarClick'
                          :allowExcelExport='true' :excelExportComplete='excelExportComplete' :allowReordering='true' :excelQueryCellInfo='excelQueryCellInfo'
                          :allowSorting='true' :toolbar='toolbar' :pageSettings='pageSettings' :actionBegin="actionBegin" :queryCellInfo='queryCellInfo'
                          :actionComplete='actionComplete' :actionFailure="actionFailure" :filterSettings='filterOptions' width="100%" height="100%">
                    <e-columns>
                        <e-column field='currencyConversionLogId' headerText='Log Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='currencyConversionId' headerText='Currency Conversion Id' width=120 :visible='true'></e-column>
                        <e-column field='code' headerText='Conversion Identifier' width=120></e-column>
                        <e-column field='currencyFrom' headerText='Currency From' textAlign='Left' width=120></e-column>
                        <e-column field='currencyTo' headerText='Currency To' textAlign='Left' width=120></e-column>
                        <e-column field='providerTypeName' headerText='Provider Type' textAlign='Left' width=150 type="string"></e-column>
                        <e-column field='logDate' headerText='Log Date' textAlign='Left' width=120 type="date" :format='dateFormatOptions'></e-column>
                        <e-column field='logTime' headerText='Log Time' textAlign='Left' type='string' width=120></e-column>
                        <e-column field='userName' headerText='User' textAlign='Left' width=150 type="string"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport } from "@syncfusion/ej2-vue-grids";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../../common/syncfusion';
    import gridOptions from '../../../common/gridOptions'
    import store from '../../../store';
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);

    Vue.use(GridPlugin);


    export default {
        components: {
        },
        data() {
            return {
                store: store,
                ccLogsData: SyncHelper.getDataManager("CurrencyConversionsLog"),
                pageSettings: gridOptions.pageSettings,
                filterOptions: gridOptions.filterSettings,
                toolbar: ['ExcelExport'],
                filterOptions: gridOptions.filterSettings,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } }
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "Currency Conversions Logs.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.gridccl.hideSpinner();
            },
            actionBegin(args) {

                if (args.requestType == 'refresh') {
                    gridOptions.actionBegin(args);
                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
           
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            queryCellInfo(args) {

                if (args.column.field === 'logTime') {
                    args.cell.textContent = this.convertUTCDateToLocalTime(args.data['logDate']);
                }
                if (args.column.field === 'logDate') {
                    args.cell.textContent = this.convertUTCDateToLocaDate(args.data['logDate']);
                }
            },
            excelQueryCellInfo: function (args) {
                if (args.column.field === 'logTime') {
                    args.value = this.convertUTCDateToLocalTime(args.data['logDate']);
                }
                if (args.column.field === 'logDatw') {
                    args.value = this.convertUTCDateToLocaDate(args.data['logDate']);
                }
            },
            convertUTCDateToLocalTime(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleTimeString();
            },
            convertUTCDateToLocaDate(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleDateString();
            }
        },

        provide: {
            grid: [Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport]
        }
    };

</script>
<style>
</style>
